<div class="copo-container settings-general">
	<div class="card-block">
		<div class="card-title">
			<div class="card-title-label " translate>user.card.about-cookies.title</div>
		</div>
		<div class="privacy-settings">
			<span translate>user.card.about-cookies</span>
		</div>
		<div class="card-title">
			<div class="card-title-label " translate>user.card.cookies-exempt-from-consents.title</div>
		</div>
		<div class="privacy-settings">
				<span translate>user.card.cookies-exempt-from-consents.one</span>
				<br/>
				<span translate>user.card.cookies-exempt-from-consents.two</span>
				<br/>
				<span translate>user.card.cookies-exempt-from-consents.three</span>
		</div>
	</div>
</div>
<ng-template #loading>
	<copo-loading-spinner></copo-loading-spinner>
</ng-template>
